import axios from '../axios';
import moment from 'moment';
import numeral from 'numeral';
import React, { useEffect, useState } from 'react';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import { makeStyles } from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Button,
  Typography,
  Grid,
} from '@material-ui/core';
import DomainVerificationIcon from '@mui/icons-material/DomainVerification';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

//import './dashboard.css'
import './dashboard.css';
import {
  Badge,
  Card,
  CardBody,
  CardHeader,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
  Label,
  Row,
} from 'reactstrap';
// import Stack from '@mui/material/Stack';
import Col from 'reactstrap/lib/Col';
import SweetAlert from 'react-bootstrap-sweetalert';

import { Grow, Slide } from '@mui/material';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    '& .MuiTableCell-root': {
      borderLeft: '1px solid rgba(224, 224, 224, 1)',
    },
  },
});
function DashboardOld() {
  const [dashboarddata, setdashboarddata] = useState([]);
  const [pendingcount, setpendingcount] = useState('');
  const [usertype, setusertype] = useState('');
  const classes = useStyles();
  const [Norecordfd, setNorecordfd] = useState(false);
  const [indentFlag, setindentFlag] = useState(false)
  const [poFlag, setpoFlag] = useState(false)

  const [poUserLogin, setPoUserLogin] = useState(false)


  const Getdashboarddata = () => {
    document.getElementById('card213').className = 'card133bd';

    const token = sessionStorage.getItem('AuthToken');
    const customerid = sessionStorage.getItem('Customer_Log');
    ////console.log(customerid)
    const getdash = axios.instance
      .get(`/Cus/${customerid}`, {
        headers: { Authorization: token, 'Content-Type': 'application/json' },
      })
      .then(res => {
        for (const data of res.data) {
          sessionStorage.setItem('Companyid', data.Company_Id);
          sessionStorage.setItem('combranch', data.combranch);
          sessionStorage.setItem('StateId', data.StateId);
          sessionStorage.setItem('Statename', data.State);
          sessionStorage.setItem('StateCode', data.StateCode);
          sessionStorage.setItem('COMPANY_STATECODE', data.COMPANY_STATECODE);
          sessionStorage.setItem('IGSTApplicable', data.IGSTApplicable);
          sessionStorage.setItem('RegisterType', data.RegisterType);

          //console.log('test', data.StateCode)
        }
      });
  };

  const getDashboardvalues = async () => {
    const Customerid = sessionStorage.getItem('Customer_Log');
    const Branchid = sessionStorage.getItem('Branch_Log');
    const token = sessionStorage.getItem('AuthToken');
    const Dash = axios.instance.get(`/Pending/${Customerid}/${Branchid}`, {
      headers: { Authorization: token, 'Content-Type': 'application/json' },
    });
    //console.log(Dash.data.length)
    setdashboarddata(Dash.data);
    console.log(Dash.data, 'getDashboardvalues');
    //setpendingcount(Dash.data.length)
  };

  const Getdatafordashboard = () => {
    const Customerid = sessionStorage.getItem('Customer_Log');
    const Branchid = sessionStorage.getItem('Branch_Log');
    const token = sessionStorage.getItem('AuthToken');
    const AdminUser = sessionStorage.getItem('AdminUser');
    //  console.log('CUS',Customerid)
    // console.log('brn',Branchid)
    setusertype(AdminUser);
    if (AdminUser === 'Y') {
      const Dash = axios.instance
        .get(
          `/PoDashview/${Customerid}/Y/${Branchid}/N/${sessionStorage.getItem(
            'Userid',
          )}`,
          {
            headers: {
              Authorization: token,
              'Content-Type': 'application/json',
            },
          },
        )
        .then(res => {
          setdashboarddata(res.data);
          console.log(res.data, 'setdashboarddata');
          setpendingcount(res.data.length);
        });
      // console.log(Dash.data)
      // console.log('gg',AdminUser)
      // console.log('cus',Customerid)
      //setpendingcount(Dash.data.length)
    } else {
      const Dash = axios.instance
        .get(
          `/PoDashview/${Customerid}/${AdminUser}/${Branchid}/${paymenttype}/${sessionStorage.getItem(
            'Userid',
          )}`,
          {
            headers: {
              Authorization: token,
              'Content-Type': 'application/json',
            },
          },
        )
        .then(res => {
          setdashboarddata(res.data);

          console.log(res.data, 'setdashboarddata');
          ///setpendingcount(Dash.data.length)
          setpendingcount(res.data.length);
        });
    }
  };
  const Getdatafordashboard1 = () => {
    setcard1(true);
    setcard2(false);
    setcard3(false);
    const Customerid = sessionStorage.getItem('Customer_Log');
    const Branchid = sessionStorage.getItem('Branch_Log');
    const token = sessionStorage.getItem('AuthToken');
    const AdminUser = sessionStorage.getItem('AdminUser');
    /// console.log('CUS',Customerid)
    //  console.log('brn',Branchid)
    setusertype(AdminUser);
    if (AdminUser === 'Y') {
      const Dash = axios.instance
        .get(
          `/PoDashview/${Customerid}/Y/${Branchid}/N/${sessionStorage.getItem(
            'Userid',
          )}`,
          {
            headers: {
              Authorization: token,
              'Content-Type': 'application/json',
            },
          },
        )
        .then(res => {
          setdashboarddata(res.data);
          console.log(res.data, 'setdashboarddata');
          setpendingcount(res.data.length);
        });
      // console.log(Dash.data)
      //  console.log('gg',AdminUser)
      //  console.log('cus',Customerid)
      //setpendingcount(Dash.data.length)
    } else {
      const Dash = axios.instance
        .get(
          `/PoDashview/${Customerid}/${AdminUser}/${Branchid}/${paymenttype}/${sessionStorage.getItem(
            'Userid',
          )}`,
          {
            headers: {
              Authorization: token,
              'Content-Type': 'application/json',
            },
          },
        )
        .then(res => {
          setdashboarddata(res.data);
          console.log(res.data, 'setdashboarddata');
          //console.log(Dash.data)
          ///setpendingcount(Dash.data.length)
          setpendingcount(res.data.length);
        });
    }
  };

  const Getdatafordashboard3 = () => {
    setcard1(false);
    setcard2(true);
    setcard3(false);
    const Customerid = sessionStorage.getItem('Customer_Log');
    const Branchid = sessionStorage.getItem('Branch_Log');
    const token = sessionStorage.getItem('AuthToken');
    const AdminUser = sessionStorage.getItem('AdminUser');
    /// console.log('CUS',Customerid)
    //  console.log('brn',Branchid)
    setusertype(AdminUser);
    if (AdminUser === 'Y') {
      const Dash = axios.instance
        .get(
          `/PoDashview/${Customerid}/Y/${Branchid}/Y/${sessionStorage.getItem(
            'Userid',
          )}`,
          {
            headers: {
              Authorization: token,
              'Content-Type': 'application/json',
            },
          },
        )
        .then(res => {
          setdashboarddata(res.data);
          console.log(res.data, 'setdashboarddata');
          setpendingcount(res.data.length);
        });
      // console.log(Dash.data)
      //  console.log('gg',AdminUser)
      //  console.log('cus',Customerid)
      //setpendingcount(Dash.data.length)
    } else {
      const Dash = axios.instance
        .get(
          `/PoDashview/${Customerid}/${AdminUser}/${Branchid}/Y/${sessionStorage.getItem(
            'Userid',
          )}`,
          {
            headers: {
              Authorization: token,
              'Content-Type': 'application/json',
            },
          },
        )
        .then(res => {
          setdashboarddata(res.data);
          console.log(res.data, 'setdashboarddata');
          //console.log(Dash.data)
          ///setpendingcount(Dash.data.length)
          setpendingcount(res.data.length);
        });
    }
  };
  const [username, setusername] = useState('');
  const [paymenttype, setpaymenttype] = useState('N');
  const [state, setstate] = useState('');
  const pages = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100];
  const [page, setpage] = useState(0);
  const [rowsperpage, setrowsperpage] = useState(pages[page]);
  const [completecouts, setcompletecouts] = useState('');
  const [deliveredCounts, setdeliveredCounts] = useState('')
  const [statuscounsts, setstatuscounsts] = useState('');
  const [card1, setcard1] = useState(false);
  const [card2, setcard2] = useState(false);
  const [card3, setcard3] = useState(false);
  const [card4, setcard4] = useState(false);
  const [FromDate, setFromDate] = useState(new Date());
  const [Todate, setTodate] = useState(new Date());

  const [poraised, setporaised] = useState(0);
  const [popending, setpopending] = useState(0);
  const [poapproved, setpoapproved] = useState(0);

  const [showFullText, setShowFullText] = useState(false);
  const [fromdatee, setfromdatee] = useState('');
  const [todate1, settodate1] = useState('');
  const [toodate, settoodate] = useState('');

  // const [statuscounsts, setstatuscounsts] = useState('');
  // const [completecouts, setcompletecouts] = useState('');
  // const [statuscounsts, setstatuscounsts] = useState('');

  useEffect(() => {
    var date = new Date();
    var firstday = new Date(date.getFullYear(), date.getMonth(), 1);
    // var lastday =  new Date(date.getFullYear(), date.getMonth()+1,0)
    var lastday = new Date(
      date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate(),
    );
    var lastdays = new Date(
      date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate(),
    );
    setfromdatee(moment(firstday).format('YYYYMMDD'));
    settoodate(moment(lastday).format('YYYYMMDD'));
    settodate1(moment(lastdays).format('YYYYMMDD'));

    const GetnoadminData = async (firstday, lastday) => {
      const Customerid = sessionStorage.getItem('Customer_Log');
      const Branchid = sessionStorage.getItem('Branch_Log');
      const userid = sessionStorage.getItem('Userid');
      const token = sessionStorage.getItem('AuthToken');

      const Dash = await axios.instance
        .post(
          `/DashboardNew`,
          {
            Admin: sessionStorage.getItem('AdminUser'),
            Special_User1: sessionStorage.getItem('Special_User1'),
            // "PO_Access": sessionStorage.getItem('PO_ACCESS'),
            // "ALL_BRANCH": sessionStorage.getItem('ALL_BRANCH'),
            DashStatus: 'TotalPO',
            Customer_Id: Customerid,
            Cus_Branchid: Branchid,
            FromDate: moment(firstday).format('YYYYMMDD'),
            Todate: moment(lastday).format('YYYYMMDD'),
            User_Id: userid,
          },

          {
            headers: {
              Authorization: token,
              'Content-Type': 'application/json',
            },
          },
        )
        .then(res => {
          setdashboarddata(res.data);
          //setpendingcount(res.data.length)
        });
      setcard1(false);
      setcard2(false);
      setcard3(true);
      setpage(0);
    };

    GetnoadminData(firstday, lastday)


    setcard3(true);

    // GetnoadminData1();
    // GetnoadminData();
    // GetnoadminData2();
    // Getdashboarddata();
    const getusername = () => {
      const user = sessionStorage.getItem('Username');
      const Admiuseruser = sessionStorage.getItem('AdminUser');
      const reequser = sessionStorage.getItem('approvereq');
      // if(Admiuseruser === 'Y') {
      //   navigation.navigate('Approval')
      // }
      // else{
      //   navigation.navigate('purchase')
      // }
      setusername(user);
    };

    getusername();

    // //if(sessionStorage.getItem('Approval2') === 'N' && sessionStorage.getItem('Approval3') ==='N' && sessionStorage.getItem('AdminUser') === 'N')  {
    // if (sessionStorage.getItem('Approval2') === 'Y') {
    //   GetnoadminData1();
    // }
    // if (sessionStorage.getItem('Approval3') === 'Y') {
    //   GetnoadminData2();
    // }

    // if (sessionStorage.getItem('AdminUser') === 'Y') {
    //   GetnoadminData();
    //   GetnoadminData1();
    //   GetnoadminData2();
    // }

    //   }else {
    // // complteapproves()
    // //   Getdatafordashboard()
    // //  getdsh()
    // //   purchasepo()

    //   }

    Getbalancen();
    PoCount(firstday, lastday);
  }, []);

  const handleChangePage = (event, newPage) => {
    setpage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setrowsperpage(parseInt(event.target.value, 10));
    // setpage(0);
  };

  const changepage = () => {
    return dashboarddata.slice(page * rowsperpage, (page + 1) * rowsperpage);
  };

  const complteapproves = async () => {
    // //console.log('called')
    var date = new Date();
    var firstday = new Date(date.getFullYear(), date.getMonth(), 1);
    console.log(firstday);
    const tokent = sessionStorage.getItem('authtoken');
    const type = sessionStorage.getItem('AdminUser');
    const branch = sessionStorage.getItem('Branch_Log');
    const cuslog = sessionStorage.getItem('Customer_Log');
    //console.log('ee',cuslog)
    // console.log('rr',branch)
    const aprovvas = await axios.instance
      .get(
        `/completeapprovals/${cuslog}/${branch}/${moment(firstday).format(
          'YYYYMMDD',
        )}/${moment(new Date()).format('YYYYMMDD')}/${sessionStorage.getItem(
          'Userid',
        )}`,
        {
          headers: {
            Authorization: tokent,
            'Content-Type': 'application/json',
          },
        },
      )
      .then(res => {
        setdashboarddata(res.data);
        console.log(res.data, 'setdashboarddata');

        // console.log('complet',res.data)
      });
  };

  const getdsh = async () => {
    const Customerid = sessionStorage.getItem('Customer_Log');
    const Branchid = sessionStorage.getItem('Branch_Log');
    const token = sessionStorage.getItem('AuthToken');
    const AdminUser = sessionStorage.getItem('AdminUser');

    const Dash = await axios.instance
      .get(
        `/PoDashview/${Customerid}/${AdminUser}/${Branchid}/Y/${sessionStorage.getItem(
          'Userid',
        )}`,
        {
          headers: { Authorization: token, 'Content-Type': 'application/json' },
        },
      )
      .then(res => {
        // setdashboarddata(res.data)
        setcompletecouts(res.data.length);
      });

    //setpendingcount(Dash.data.length)
  };

  const Getbalancen = async () => {
    const Customerid = sessionStorage.getItem('Customer_Log');
    const Branchid = sessionStorage.getItem('Branch_Log');
    const token = sessionStorage.getItem('AuthToken');
    const AdminUser = sessionStorage.getItem('AdminUser');

    const Dash = await axios.instance
      .get(`/contractChkbal/${sessionStorage.getItem('contract_ID')}`, {
        headers: { Authorization: token, 'Content-Type': 'application/json' },
      })
      .then(res => {
        for (const Data2 of res.data) {
          sessionStorage.setItem('Contract_Value', Data2.Contract_Value);
          sessionStorage.setItem('PO_Value', Data2.PO_Value);
          sessionStorage.setItem('balance', Data2.balance);
        }
      });

    //setpendingcount(Dash.data.length)
  };

  // const GetnoadminData = async () => {
  //   const Customerid = sessionStorage.getItem('Customer_Log');
  //   const Branchid = sessionStorage.getItem('Branch_Log');
  //   const token = sessionStorage.getItem('AuthToken');
  //   const AdminUser =
  //     sessionStorage.getItem('AdminUser') === 'N' &&
  //     sessionStorage.getItem('Approval3') === 'N'
  //       ? 'N'
  //       : 'Y';
  //   // const AdminUser  =  sessionStorage.getItem('AdminUser')

  //   const Dash = await axios.instance
  //     .get(
  //       `/PoDashviewUser/${1}/${Customerid}/${Branchid}/${sessionStorage.getItem(
  //         'Userid',
  //       )}/${AdminUser}/${sessionStorage.getItem('Approval2')}`,
  //       {
  //         headers: { Authorization: token, 'Content-Type': 'application/json' },
  //       },
  //     )
  //     .then(res => {
  //       setdashboarddata(res.data);
  //       setpopending(res.data.length, 'popending');
  //       //setpendingcount(res.data.length)
  //       console.log(res.data, 'level1');
  //     });
  //   setcard1(true);
  //   setcard2(false);
  //   setcard3(false);
  //   setpage(0);
  // };

  // const GetnoadminData1 = async () => {
  //   const Customerid = sessionStorage.getItem('Customer_Log');
  //   const Branchid = sessionStorage.getItem('Branch_Log');
  //   const token = sessionStorage.getItem('AuthToken');
  //   const AdminUser =
  //     sessionStorage.getItem('AdminUser') === 'N' &&
  //     sessionStorage.getItem('Approval3') === 'N'
  //       ? 'N'
  //       : 'Y';
  //   // const AdminUser  =  sessionStorage.getItem('AdminUser')

  //   const Dash = await axios.instance
  //     .get(
  //       `/PoDashviewUser/${2}/${Customerid}/${Branchid}/${sessionStorage.getItem(
  //         'Userid',
  //       )}/${AdminUser}/${sessionStorage.getItem('Approval2')}`,
  //       {
  //         headers: { Authorization: token, 'Content-Type': 'application/json' },
  //       },
  //     )
  //     .then(res => {
  //       setdashboarddata(res.data);
  //       setpoapproved(res.data.length, 'poapproved');
  //       //setstatuscounsts(res.data.length)
  //       console.log(res.data, 'level2');
  //     });
  //   setcard1(false);
  //   setcard2(true);
  //   setcard3(false);
  //   setpage(0);
  // };

  // const GetnoadminData2 = async () => {
  //   const Customerid = sessionStorage.getItem('Customer_Log');
  //   const Branchid = sessionStorage.getItem('Branch_Log');
  //   const token = sessionStorage.getItem('AuthToken');
  //   const AdminUser =
  //     sessionStorage.getItem('AdminUser') === 'N' &&
  //     sessionStorage.getItem('Approval3') === 'N'
  //       ? 'N'
  //       : 'Y';
  //   // const AdminUser  =  sessionStorage.getItem('AdminUser')

  //   const Dash = await axios.instance
  //     .get(
  //       `/PoDashviewUser/${4}/${Customerid}/${sessionStorage.getItem(
  //         'Branch_Log',
  //       )}/${sessionStorage.getItem(
  //         'Userid',
  //       )}/${AdminUser}/${sessionStorage.getItem('Approval2')}`,
  //       {
  //         headers: { Authorization: token, 'Content-Type': 'application/json' },
  //       },
  //     )
  //     .then(res => {
  //       setdashboarddata(res.data);
  //       setporaised(res.data.length, 'poraised');
  //       console.log(res.data.length, 'poraised');
  //       //  setcompletecouts(res.data.length)
  //       console.log(res.data, 'level3');
  //     });
  //   setcard1(false);
  //   setcard2(false);
  //   setcard3(true);
  //   setpage(0);
  // };

  const getdsh1 = async () => {
    // document.getElementById("card212").className = "card133bd"
    // console.log()
    const Customerid = sessionStorage.getItem('Customer_Log');
    const Branchid = sessionStorage.getItem('Branch_Log');
    const token = sessionStorage.getItem('AuthToken');
    const AdminUser = sessionStorage.getItem('AdminUser');

    const Dash = await axios.instance
      .get(
        `/PoDashview/${Customerid}/${AdminUser}/${Branchid}/Y/${sessionStorage.getItem(
          'Userid',
        )}`,
        {
          headers: { Authorization: token, 'Content-Type': 'application/json' },
        },
      )
      .then(res => {
        setdashboarddata(res.data);
        console.log(res.data, 'setdashboarddata');
        //  setcompletecouts(res.data.length)
      });
    setcard1(false);
    setcard2(false);
    setcard3(true);
    //setpendingcount(Dash.data.length)
  };
  const purchasepo = async () => {
    const tokent = sessionStorage.getItem('authtoken');
    const branchid = sessionStorage.getItem('Branch_Log');
    const custoemrid = sessionStorage.getItem('Customer_Log');
    const AdminUser = sessionStorage.getItem('AdminUser');
    ////console.log(branchid,custoemrid,Usertype)
    const purchases = await axios.instance
      .get(
        `/PoDashview/${custoemrid}/${AdminUser}/${branchid}/Y/${sessionStorage.getItem(
          'Userid',
        )}`,
        {
          headers: {
            Authorization: tokent,
            'Content-Type': 'application/json',
          },
        },
      )
      .then(res => {
        //setpurchase(purchases.data)
        setstatuscounsts(res.data.length);
      });
  };
  // const PoCount = async () => {
  //   const tokent = sessionStorage.getItem('authtoken');
  //   const custoemrid = sessionStorage.getItem('Customer_Log');
  //   const branchid = sessionStorage.getItem('Branch_Log');
  //   const purchases = await axios.instance
  //     .get(`/PoCount/${1}/${custoemrid}/${branchid}`, {
  //       headers: { Authorization: tokent, 'Content-Type': 'application/json' },
  //     })
  //     .then(res => {
  //       console.log(res.data, 'coutns');
  //       for (const Data of res.data) {
  //         setcompletecouts(Data.PoStatus);
  //       }
  //     })
  //     .then(async res => {
  //       const custoemrid = sessionStorage.getItem('Customer_Log');
  //       const purchases = await axios.instance
  //         .get(`/PoCount/${2}/${custoemrid}/${branchid}`, {
  //           headers: {
  //             Authorization: tokent,
  //             'Content-Type': 'application/json',
  //           },
  //         })
  //         .then(res => {
  //           for (const Data of res.data) {
  //             setpendingcount(Data.Pending);
  //           }
  //         });
  //     })
  //     .then(async res => {
  //       const custoemrid = sessionStorage.getItem('Customer_Log');
  //       const purchases = await axios.instance
  //         .get(`/PoCount/${3}/${custoemrid}/${branchid}`, {
  //           headers: {
  //             Authorization: tokent,
  //             'Content-Type': 'application/json',
  //           },
  //         })
  //         .then(res => {
  //           for (const Data of res.data) {
  //             setstatuscounsts(Data.Approved);
  //           }
  //         });
  //     });
  // };
  const handleMouseEnter = () => {
    setShowFullText(true);
  };

  const handleMouseLeave = () => {
    setShowFullText(false);
  };

  const GetnoadminData = async () => {
    const Customerid = sessionStorage.getItem('Customer_Log');
    const Branchid = sessionStorage.getItem('Branch_Log');
    const userid = sessionStorage.getItem('Userid');
    const token = sessionStorage.getItem('AuthToken');

    const Dash = await axios.instance
      .post(
        `/DashboardNew`,
        {
          Admin: sessionStorage.getItem('AdminUser'),
          Special_User1: sessionStorage.getItem('Special_User1'),
          // "PO_Access": sessionStorage.getItem('PO_ACCESS'),
          // "ALL_BRANCH": sessionStorage.getItem('ALL_BRANCH'),
          DashStatus: 'TotalPO',
          Customer_Id: Customerid,
          Cus_Branchid: Branchid,
          FromDate: fromdatee,
          Todate: toodate,
          User_Id: userid,
        },

        {
          headers: { Authorization: token, 'Content-Type': 'application/json' },
        },
      )
      .then(res => {
        setdashboarddata(res.data);
        //setpendingcount(res.data.length)
      });
    setcard1(false);
    setcard2(false);
    setcard3(true);
    setcard4(false); // Delivered PO
    setpage(0);
  };

  const GetnoadminData1 = async () => {
    const Customerid = sessionStorage.getItem('Customer_Log');
    const Branchid = sessionStorage.getItem('Branch_Log');
    const userid = sessionStorage.getItem('Userid');
    const token = sessionStorage.getItem('AuthToken');

    const Dash = await axios.instance
      .post(
        `/DashboardNew`,
        {
          Admin: sessionStorage.getItem('AdminUser'),
          Special_User1: sessionStorage.getItem('Special_User1'),
          // "PO_Access": sessionStorage.getItem('PO_ACCESS'),
          // "ALL_BRANCH": sessionStorage.getItem('ALL_BRANCH'),
          DashStatus: 'PORaise',
          Customer_Id: Customerid,
          Cus_Branchid: Branchid,
          FromDate: fromdatee,
          Todate: toodate,
          User_Id: userid,
        },

        {
          headers: { Authorization: token, 'Content-Type': 'application/json' },
        },
      )
      .then(res => {
        setdashboarddata(res.data);
        //setstatuscounsts(res.data.length)
      });
    setcard1(false); //pendingcard
    setcard2(true); //Approve
    setcard3(false); //total indent
    setcard4(false); // Delivered PO
    setpage(0);
  };

    const GetnoadminData3 = async () => {
    const Customerid = sessionStorage.getItem('Customer_Log');
    const Branchid = sessionStorage.getItem('Branch_Log');
    const userid = sessionStorage.getItem('Userid');
    const token = sessionStorage.getItem('AuthToken');

    const Dash = await axios.instance
      .post(
        `/DashboardNew`,
        {
          Admin: sessionStorage.getItem('AdminUser'),
          Special_User1: sessionStorage.getItem('Special_User1'),
          // "PO_Access": sessionStorage.getItem('PO_ACCESS'),
          // "ALL_BRANCH": sessionStorage.getItem('ALL_BRANCH'),
          DashStatus: 'Delivered',
          Customer_Id: Customerid,
          Cus_Branchid: Branchid,
          FromDate: fromdatee,
          Todate: toodate,
          User_Id: userid,
        },

        {
          headers: { Authorization: token, 'Content-Type': 'application/json' },
        },
      )
      .then(res => {
        setdashboarddata(res.data);
        //setstatuscounsts(res.data.length)
      });
    setcard1(false); //pendingcard
    setcard2(false); //Approve
    setcard3(false); //total indent
    setcard4(true); //Delivered PO
    setpage(0);
  };


  const GetnoadminData2 = async () => {
    const Customerid = sessionStorage.getItem('Customer_Log');
    const Branchid = sessionStorage.getItem('Branch_Log');
    const userid = sessionStorage.getItem('Userid');
    const token = sessionStorage.getItem('AuthToken');

    const Dash = await axios.instance
      .post(
        `/DashboardNew`,
        {
          Admin: sessionStorage.getItem('AdminUser'),
          Special_User1: sessionStorage.getItem('Special_User1'),
          // "PO_Access": sessionStorage.getItem('PO_ACCESS'),
          // "ALL_BRANCH": sessionStorage.getItem('ALL_BRANCH'),
          DashStatus: 'Onnum',
          Customer_Id: Customerid,
          Cus_Branchid: Branchid,
          FromDate: fromdatee,
          Todate: toodate,
          User_Id: userid,
        },

        {
          headers: { Authorization: token, 'Content-Type': 'application/json' },
        },
      )
      .then(res => {
        setdashboarddata(res.data);
        console.log(res.data.length, 'onclicklength');
        //  setcompletecouts(res.data.length)
      });
    setcard1(true);
    setcard2(false);
    setcard3(false);
    setcard4(false); // Delivered PO
    setpage(0);
  };

  const PoCount = async (id, id1) => {
    const Customerid = sessionStorage.getItem('Customer_Log');
    const Branchid = sessionStorage.getItem('Branch_Log');
    const userid = sessionStorage.getItem('Userid');
    const token = sessionStorage.getItem('AuthToken');
    const purchases = await axios.instance
      .post(
        `/DashboardNew`,
        {
          Admin: sessionStorage.getItem('AdminUser'),
          Special_User1: sessionStorage.getItem('Special_User1'),
          // "PO_Access": sessionStorage.getItem('PO_ACCESS'),
          // "ALL_BRANCH": sessionStorage.getItem('ALL_BRANCH'),
          DashStatus: 'TotalPO',
          Customer_Id: Customerid,
          Cus_Branchid: Branchid,
          FromDate: moment(id).format('YYYYMMDD'),
          Todate: moment(id1).format('YYYYMMDD'),
          User_Id: userid,
        },

        {
          headers: { Authorization: token, 'Content-Type': 'application/json' },
        },
      )
      .then(res => {
        // for (const Data of res.data) {
        // setcompletecouts(res.data.length);
        setpendingcount(res.data.length);
        // }
      })
      .then(async res => {
        const custoemrid = sessionStorage.getItem('Customer_Log');
        const purchases = await axios.instance
          .post(
            `/DashboardNew`,
            {
              Admin: sessionStorage.getItem('AdminUser'),
              Special_User1: sessionStorage.getItem('Special_User1'),
              // "PO_Access": sessionStorage.getItem('PO_ACCESS'),
              // "ALL_BRANCH": sessionStorage.getItem('ALL_BRANCH'),
              DashStatus: 'PORaise',
              Customer_Id: Customerid,
              Cus_Branchid: Branchid,
              FromDate: moment(id).format('YYYYMMDD'),
              Todate: moment(id1).format('YYYYMMDD'),
              User_Id: userid,
            },

            {
              headers: {
                Authorization: token,
                'Content-Type': 'application/json',
              },
            },
          )
          .then(res => {
            // for (const Data of res.data) {
            // setstatuscounsts(res.data.length);
            setcompletecouts(res.data.length);
            // }
          });
      })
      // delivered
      .then(async res => {
        const custoemrid = sessionStorage.getItem('Customer_Log');
        const purchases = await axios.instance
          .post(
            `/DashboardNew`,
            {
              Admin: sessionStorage.getItem('AdminUser'),
              Special_User1: sessionStorage.getItem('Special_User1'),
              // "PO_Access": sessionStorage.getItem('PO_ACCESS'),
              // "ALL_BRANCH": sessionStorage.getItem('ALL_BRANCH'),
              DashStatus: 'Delivered',
              Customer_Id: Customerid,
              Cus_Branchid: Branchid,
              FromDate: moment(id).format('YYYYMMDD'),
              Todate: moment(id1).format('YYYYMMDD'),
              User_Id: userid,
            },

            {
              headers: {
                Authorization: token,
                'Content-Type': 'application/json',
              },
            },
          )
          .then(res => {
            // for (const Data of res.data) {
            // setstatuscounsts(res.data.length);
            // setcompletecouts(res.data.length);
            setdeliveredCounts(res.data.length);
            
            // }
          });
      })
      .then(async res => {
        const custoemrid = sessionStorage.getItem('Customer_Log');
        const purchases = await axios.instance
          .post(
            `/DashboardNew`,
            {
              Admin: sessionStorage.getItem('AdminUser'),
              Special_User1: sessionStorage.getItem('Special_User1'),
              // "PO_Access": sessionStorage.getItem('PO_ACCESS'),
              // "ALL_BRANCH": sessionStorage.getItem('ALL_BRANCH'),
              DashStatus: 'Onnum',
              Customer_Id: Customerid,
              Cus_Branchid: Branchid,
              FromDate: moment(id).format('YYYYMMDD'),
              Todate: moment(id1).format('YYYYMMDD'),
              User_Id: userid,
            },

            {
              headers: {
                Authorization: token,
                'Content-Type': 'application/json',
              },
            },
          )
          .then(res => {
            // for (const Data of res.data) {
            // setcompletecouts(res.data.length);
            setstatuscounsts(res.data.length);
            console.log(res.data.length, 'length');
            // }
          });
      });
  };
  return (
    <>
      <Row>
        <Col lg="12">
          <Grow in={true} timeout={1000}>
            {/* <Slide direction="down" in={true} mountOnEnter unmountOnExit>            */}
            <div className="threecard" id="threecard">
              <Row>
                {card3 ? (
                   <Col lg={3} md={3} sm={6} xs={12}>
                    <Card
                      style={{ border: 'none' }}
                      className="card1"
                      onClick={() => {
                        GetnoadminData()
                        setindentFlag(false)
                        setpoFlag(false)

                      }}
                    >
                      <CardBody className="card133bd" id="card211">
                        <PendingActionsIcon
                          size="large"
                          style={{ fontSize: '60px' }}
                        />
                        {sessionStorage.getItem('AdminUser') === 'N' &&
                          sessionStorage.getItem('Special_User1') === 'N' ? (
                          <p> Total Indents </p>
                        ) : (
                          <p>Total PO</p>
                        )}{' '}
                        <b style={{ fontSize: '1.4rem' }}>{pendingcount}</b>
                        <ArrowDropDownIcon fontSize="5px" />
                      </CardBody>
                    </Card>
                  </Col>
                ) : (
                    <Col lg={3} md={3} sm={6} xs={12}>
                    <Card
                      style={{ border: 'none' }}
                      className="card1"
                      id="card211"
                      onClick={() => {

                        setPoUserLogin(false)
                        GetnoadminData()
                        setindentFlag(false)
                        setpoFlag(false)

                      }}
                    >
                      <CardBody
                        className="card12bd"
                        style={{ borderRadius: '20px' }}
                      >
                        <PendingActionsIcon
                          size="large"
                          style={{ fontSize: '60px' }}
                        />
                        {/* <p>PO Status</p>{' '} */}
                        {sessionStorage.getItem('AdminUser') === 'N' &&
                          sessionStorage.getItem('Special_User1') === 'N' ? (
                          <p> Total Indents </p>
                        ) : (
                          <p>Total PO</p>
                        )}{' '}
                        <b style={{ fontSize: '2rem' }}>{pendingcount}</b>
                      </CardBody>
                    </Card>
                  </Col>
                )}
              </Row>
              <Row>
                {card1 ? (
                    <Col lg={3} md={3} sm={6} xs={12}>
                    <Card
                      style={{
                        border: 'none',
                        backgroundColor: 'white',
                        boxShadow: 'none',
                      }}
                      className="cardyellow"
                      onClick={(e) => {


                        GetnoadminData2()
                        setpoFlag(false)
                        // if (e.target.tagName === 'P' && e.target.textContent.trim() === 'Pending Indents For PO') {
                        setindentFlag(true);
                        console.log('indentFlag set to true');
                        // }
                        console.log(e.target.textContent, 'mudichita');
                      }}
                    >
                      <CardBody className="card133bd" id="card213">
                        <div style={{ pointerEvents: 'none' }}>
                          {/* Prevents clicks on the icon */}
                          <EmojiObjectsIcon
                            size="large"
                            style={{ fontSize: '60px' }}
                          />
                        </div>
                        {sessionStorage.getItem('AdminUser') === 'N' &&
                          sessionStorage.getItem('Special_User1') === 'N' ? (
                          <p> Pending Indents </p>
                        ) : (
                          <p>Pending Indents For PO</p>
                        )}{' '}
                        {/* <p>Pending</p>{' '} */}
                        <b style={{ fontSize: '1.4rem', pointerEvents: 'none' }}>{statuscounsts}</b>

                        <ArrowDropDownIcon fontSize="5px" />
                      </CardBody>
                    </Card>
                  </Col>
                ) : (
                     <Col lg={3} md={3} sm={6} xs={12}>
                    <Card
                      style={{ border: 'none', backgroundColor: 'white' }}
                      className="card1"
                      id="card213"
                      onClick={e => {
                        GetnoadminData2();
                        setPoUserLogin(true);
                        setpoFlag(false)
                        // if (e.target.textContent === 'Pending Indents For PO') {
                        //   // sessionStorage.setItem('indentuser', 'Y'); // Set indentuser to 'Y'
                        setindentFlag(true)
                        console.log('indentuser set to Y');
                        // }
                        console.log(e.target.textContent, 'mudichita');
                      }}
                    >
                      <CardBody
                        className="card1bd"
                        style={{ borderRadius: '20px' }}
                      >
                        <div style={{ pointerEvents: 'none' }}>
                          {/* Prevents clicks on the icon */}
                          <EmojiObjectsIcon
                            size="large"
                            style={{ fontSize: '60px' }}
                          />
                        </div>
                        {sessionStorage.getItem('AdminUser') === 'N' &&
                          sessionStorage.getItem('Special_User1') === 'N' ? (
                          <p> Pending Indents </p>
                        ) : (
                          <p>Pending Indents For PO</p>
                        )}{' '}
                        {/* <p>Pending </p>{' '} */}
                        <b style={{ fontSize: '2rem', pointerEvents: 'none' }}>
                          {statuscounsts}
                        </b>
                      </CardBody>
                    </Card>
                  </Col>
                )}
              </Row>
              <Row>
                {card2 ? (
                  <Col lg={3} md={3} sm={6} xs={12}>
                    <Card
                      style={{ border: 'none', backgroundColor: 'white' }}
                      className="card1"
                      onClick={() => {
                        GetnoadminData1()
                        setpoFlag(true)
                        setindentFlag(false)
                      }}
                    >
                      <CardBody className="card133bd" id="card212">
                        <DomainVerificationIcon
                          size="large"
                          style={{ fontSize: '60px' }}
                        />
                        {sessionStorage.getItem('AdminUser') === 'N' &&
                          sessionStorage.getItem('Special_User1') === 'N' ? (
                          <p> PO Raised Indents </p>
                        ) : (
                          <p>Vendor Accepted</p>
                        )}{' '}
                        {/* <p>Approved</p>{' '} */}
                        <b style={{ fontSize: '1.4rem' }}>{completecouts}</b>
                        <ArrowDropDownIcon fontSize="5px" />
                      </CardBody>
                    </Card>
                  </Col>
                ) : (
                    <Col lg={3} md={3} sm={6} xs={12}>
                    <Card
                      style={{ border: 'none', backgroundColor: 'white' }}
                      className="card1"
                      onClick={() => {
                        setPoUserLogin(false)
                        setpoFlag(true)
                        GetnoadminData1()
                        setindentFlag(false)
                      }}
                    >
                      <CardBody
                        className="card13bd"
                        style={{ borderRadius: '20px' }}
                        id="card212"
                      >
                        <DomainVerificationIcon
                          size="large"
                          style={{ fontSize: '60px' }}
                        />
                        {sessionStorage.getItem('AdminUser') === 'N' &&
                          sessionStorage.getItem('Special_User1') === 'N' ? (
                          <p> PO Raised Indents </p>
                        ) : (
                          <p>Vendor Accepted</p>
                        )}{' '}
                        {/* <p>Approved</p>{' '} */}
                        <b style={{ fontSize: '2rem' }}>{completecouts}</b>
                      </CardBody>
                    </Card>
                  </Col>
                )}
              </Row>
              {/* Delivered */}
              <Row>
                {card4 ? (
                  <Col lg={3} md={3} sm={6} xs={12}>
                    <Card
                      style={{ border: 'none', backgroundColor: 'white' }}
                      className="card1"
                      onClick={() => {
                        GetnoadminData3()
                        setpoFlag(true)
                        setindentFlag(false)
                      }}
                    >
                      <CardBody className="card133bd" id="card212">
                        <LocalShippingIcon 
                          size="large"
                          style={{ fontSize: '60px' }}
                        />
                        <p>Delivered PO</p>{' '}
                        {/* <p>Approved</p>{' '} */}
                        <b style={{ fontSize: '1.4rem' }}>{deliveredCounts}</b>
                        <ArrowDropDownIcon fontSize="5px" />
                      </CardBody>
                    </Card>
                  </Col>
                ) : (
                  <Col lg={3} md={3} sm={6} xs={12}>
                    <Card
                      style={{ border: 'none', backgroundColor: 'white' }}
                      className="card1"
                      onClick={() => {
                        setPoUserLogin(false)
                        setpoFlag(true)
                        GetnoadminData3()
                        setindentFlag(false)
                      }}
                    >
                      <CardBody
                        className="card13bd"
                        style={{ borderRadius: '20px' }}
                        id="card212"
                      >
                        <LocalShippingIcon 
                          size="large"
                          style={{ fontSize: '60px' }}
                        />
                       <p>Delivered PO</p>
                        {/* <p>Approved</p>{' '} */}
                        <b style={{ fontSize: '2rem' }}>{deliveredCounts}</b>
                      </CardBody>
                    </Card>
                  </Col>
                )}
              </Row>
            </div>
            {/* </Slide> */}
          </Grow>

          <div className="Tabelinspections">
            <TableContainer
              style={{
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
                boxShadow:
                  'rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px',
              }}
            >
              <Table className="InspectionTbls1">
                <TableHead>
                  <TableRow>
                    {sessionStorage.getItem('AdminUser') === 'N' &&
                      sessionStorage.getItem('Special_User1') === 'N' ? (
                      <TableCell align="center">Indent No</TableCell>
                    ) : indentFlag ? (
                      <TableCell align="center">Indent No</TableCell>
                    ) : (
                      <TableCell align="center">PO No</TableCell>
                    )}
                    {sessionStorage.getItem('AdminUser') === 'N' &&
                      sessionStorage.getItem('Special_User1') === 'N' ? (
                      <TableCell align="center">Indent Date</TableCell>
                    ) : indentFlag ? (
                      <TableCell align="center">Indent Date</TableCell>
                    ) : (
                      <TableCell align="center">PO Date</TableCell>
                    )}
                    {sessionStorage.getItem('AdminUser') === 'N' &&
                      sessionStorage.getItem('Special_User1') === 'N' && poFlag && (
                        <>
                          <TableCell align="center">PO NO</TableCell>
                          <TableCell align="center">PO Date</TableCell>
                        </>
                      )}
                    {/* <TableCell align="center">PO Date</TableCell> */}
                    {/* <TableCell align="center">Contract No</TableCell> */}
                    {/* {sessionStorage.getItem('customer_HO') === 'Y' ? ( */}
                    <TableCell align="center">Customer Name</TableCell>
                    {sessionStorage.getItem('AdminUser') === 'N' && sessionStorage.getItem('Special_User1') === 'N' ?
                      <TableCell align="center">Branch</TableCell>
                      : (sessionStorage.getItem('AdminUser') === 'Y' && sessionStorage.getItem('Special_User1') === 'N' && poUserLogin === true)
                      &&
                      <TableCell align="center">Branch</TableCell>
                    }

                    {/* <TableCell align="center">Department</TableCell>
                    <TableCell align="center">Designation</TableCell> */}
                    <TableCell align="right">
                      <b>₹</b> Amount
                    </TableCell>
                    <TableCell align="center">Status </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dashboarddata.length != 0 ? (
                    changepage().map((data, index) => (
                      <TableRow
                        sx={{
                          backgroundColor: 'yellow',
                          borderBottom: '2px solid black',
                          '& th': {
                            fontSize: '1.25rem',
                            color: 'rgba(96, 96, 96)',
                          },
                        }}
                      >
                        {sessionStorage.getItem('AdminUser') === 'N' &&
                          sessionStorage.getItem('Special_User1') === 'N' ? (
                          <TableCell align="center">{data.Indent_No}</TableCell>
                        ) : indentFlag ? (
                          <TableCell align="center">{data.Indent_No}</TableCell>
                        ) : (
                          <TableCell align="center">{data.Order_No}</TableCell>
                        )}
                        {sessionStorage.getItem('AdminUser') === 'N' &&
                          sessionStorage.getItem('Special_User1') === 'N' ? (
                          <TableCell align="center">
                            {data.Indent_Date}
                          </TableCell>
                        ) : indentFlag ? (
                          <TableCell align="center">
                            {data.Indent_Date}
                          </TableCell>
                        ) : (
                          <TableCell align="center">
                            {data.Order_Date}
                          </TableCell>
                        )}
                        {/* <TableCell align="center">
                          {sessionStorage.getItem('Contract_Detail_No')}
                        </TableCell> */}
                        {sessionStorage.getItem('AdminUser') === 'N' &&
                          sessionStorage.getItem('Special_User1') === 'N' && poFlag && (
                            <>
                              <TableCell align="center"> {data.Order_No}</TableCell>
                              <TableCell align="center"> {data.Order_Date}</TableCell>
                            </>
                          )}

                        <TableCell align="center">
                          {/* {sessionStorage.getItem('customer_HO') === 'Y'
                            ? data.CustomerName
                            : data.Branch_Name === null
                            ? data.CustomerName
                            : data.Branch_Name} */}
                          {data.Customer_Name}
                        </TableCell>
                        {sessionStorage.getItem('AdminUser') === 'N' &&
                          sessionStorage.getItem('Special_User1') === 'N' ? (
                          <TableCell align="center">
                            {data.Branch_Name || '-'}
                          </TableCell>
                        ) : (
                          sessionStorage.getItem('AdminUser') === 'Y' &&
                          sessionStorage.getItem('Special_User1') === 'N' &&
                          poUserLogin === true && (
                            <TableCell align="center">
                              {data.Branch_Name || '-'}
                            </TableCell>
                          )
                        )}
                        {/* Client Requirement  */}

                        {/* <TableCell align="center">{data.Department}</TableCell>
                        <TableCell align="center">{data.Designation}</TableCell> */}
                        <TableCell align="right">
                          {numeral(
                            data.NET_AMOUNT,
                            // - data.Discount_Amount,
                          ).format('0,0.00')}
                        </TableCell>
                        {sessionStorage.getItem('AdminUser') === 'N' &&
                          sessionStorage.getItem('Special_User1') === 'N' ? (
                          // <TableCell align="center">{data.Status}</TableCell>
                          data.Status === 'Not Approved' ? (
                            <TableCell
                              color="red"
                              style={{ color: '#FFC100' }}
                              align="center"
                            >
                              <Badge
                                pill
                                style={{
                                  fontSize: '13px',
                                  backgroundColor: 'red',
                                }}
                              >
                                {/* {data.Status} */}
                                Pending
                              </Badge>
                            </TableCell>
                          ) : data.Status === 'Accepted'
                            ?
                            (
                              <TableCell
                                color="red"
                                style={{ color: '#41ef35' }}
                                align="center"
                              >
                                <Badge
                                  pill
                                  style={{
                                    fontSize: '13px',
                                    backgroundColor: '#41ef35',
                                  }}
                                >
                                  {data.Status}
                                </Badge>
                              </TableCell>
                            )
                            : data.Status === 'Approved'
                              ?
                              (
                                <TableCell
                                  color="red"
                                  style={{ color: '#008001' }}
                                  align="center"
                                >
                                  <Badge
                                    style={{
                                      fontSize: '13px',
                                      backgroundColor: '#008001',
                                    }}
                                    pill
                                  >
                                    {/* {data.Status} */}
                                    PO Raised
                                  </Badge>
                                </TableCell>
                              )
                              :
                              data.Status === 'Delivered' ? (
                                <TableCell
                                  color="red"
                                  style={{ color: '#41ef35' }}
                                  align="center"
                                >
                                  <Badge
                                    pill
                                    style={{
                                      fontSize: '13px',
                                      backgroundColor: '#007BFF ',
                                    }}
                                  >
                                    {data.Status}
                                  </Badge>
                                </TableCell>
                              ) :
                                data.Status === 'Partial' ? (
                                  <TableCell
                                    color="red"
                                    style={{ color: '#41ef35' }}
                                    align="center"
                                  >
                                    <Badge
                                      pill
                                      style={{
                                        fontSize: '13px',
                                        backgroundColor: '#FFA500 ',
                                      }}
                                    >
                                      {data.Status}
                                    </Badge>
                                  </TableCell>
                                ) :
                                  (
                                    <TableCell align="center"></TableCell>
                                  )
                        ) : indentFlag ? (
                          data.Status === 'Not Approved' ? (
                            <TableCell
                              color="red"
                              style={{ color: '#FFC100' }}
                              align="center"
                            >
                              <Badge
                                pill
                                style={{
                                  fontSize: '13px',
                                  backgroundColor: 'red',
                                }}
                              >
                                {/* {data.Status} */}
                                Pending
                              </Badge>
                            </TableCell>
                          ) : (
                            <TableCell
                              color="green"
                              style={{ color: '#FFC100' }}
                              align="center"
                            >
                              <Badge
                                pill
                                style={{
                                  fontSize: '13px',
                                  backgroundColor: '#008001',
                                }}
                              >
                                {data.Status}
                              </Badge>
                            </TableCell>
                          )
                        ) : data.Status === 'Bill Raised' ? (
                          <TableCell
                            color="red"
                            style={{ color: '#FFC100' }}
                            align="center"
                          >
                            <Badge
                              pill
                              style={{
                                fontSize: '13px',
                                backgroundColor: '#FC5C7D',
                              }}
                            >
                              {data.Status}
                            </Badge>
                          </TableCell>
                        ) : data.Status == 'Stage 1 completed' ? (
                          <TableCell
                            color="#008001"
                            style={{ color: '#41ef35' }}
                            align="center"
                          >
                            <Badge
                              pill
                              style={{
                                fontSize: '13px',
                                backgroundColor: '#008001',
                              }}
                            >
                              {data.Status == 'Stage 1 completed'
                                ? 'Finalized'
                                : data.Status}
                            </Badge>
                          </TableCell>
                        ) : data.Status === 'Accepted' ? (
                          <TableCell
                            color="red"
                            style={{ color: '#41ef35' }}
                            align="center"
                          >
                            <Badge
                              pill
                              style={{
                                fontSize: '13px',
                                backgroundColor: '#41ef35',
                              }}
                            >
                              {data.Status}
                            </Badge>
                          </TableCell>
                        ) : data.Status === 'Sales order Raised' ? (
                          <TableCell
                            color="red"
                            style={{ color: '#37cbef' }}
                            align="center"
                          >
                            <Badge
                              pill
                              style={{
                                fontSize: '13px',
                                backgroundColor: '#37cbef',
                              }}
                            >
                              {data.Status}
                            </Badge>
                          </TableCell>
                        ) : data.Status === 'Stage 1 pending' ? (
                          <TableCell
                            color="red"
                            style={{ color: 'red' }}
                            align="center"
                          >
                            <Badge
                              style={{
                                fontSize: '13px',
                                backgroundColor: '#CB1033',
                              }}
                              pill
                            >
                              {data.Status == 'Stage 1 pending'
                                ? 'Awaiting Finalization'
                                : data.Status}
                            </Badge>{' '}
                          </TableCell>
                        ) : data.Status === '' ? (
                          <TableCell
                            color="red"
                            style={{ color: 'red' }}
                            align="center"
                          >
                            {data.Status === '' ? (
                              <Badge
                                pill
                                style={{
                                  fontSize: '13px',
                                  backgroundColor: '#CB1033',
                                }}
                              >
                                {data.Status == ''
                                  ? 'Awaiting Finalization'
                                  : 'Stage 1 pending'}
                              </Badge>
                            ) : (
                              ''
                            )}
                          </TableCell>
                        ) : data.Status === 'Approved' ? (
                          <TableCell
                            color="red"
                            style={{ color: '#008001' }}
                            align="center"
                          >
                            <Badge
                              style={{
                                fontSize: '13px',
                                backgroundColor: '#008001',
                              }}
                              pill
                            >
                              {/* {data.Status} */}
                              PO Raised
                            </Badge>
                          </TableCell>
                        ) : data.Status === 'DC Raised' ? (
                          <TableCell
                            color="#F7F700"
                            style={{ color: '#F7F700' }}
                            align="center"
                          >
                            <Badge
                              pill
                              style={{
                                color: '#F50000',
                                fontSize: '12px',
                                backgroundColor: '#F7F700',
                              }}
                            >
                              {data.Status}
                            </Badge>
                          </TableCell>
                        ) :

                          data.Status === 'Delivered' ? (
                            <TableCell
                              color="red"
                              style={{ color: '#41ef35' }}
                              align="center"
                            >
                              <Badge
                                pill
                                style={{
                                  fontSize: '13px',
                                  backgroundColor: '#007BFF ',
                                }}
                              >
                                {data.Status}
                              </Badge>
                            </TableCell>
                          ) :
                            data.Status === 'Partial' ? (
                              <TableCell
                                color="red"
                                style={{ color: '#41ef35' }}
                                align="center"
                              >
                                <Badge
                                  pill
                                  style={{
                                    fontSize: '13px',
                                    backgroundColor: '#FFA500 ',
                                  }}
                                >
                                  {data.Status}
                                </Badge>
                              </TableCell>
                            ) :
                              (
                                <TableCell align="center"></TableCell>
                              )}
                      </TableRow>
                    ))
                  ) : (
                    <>
                      {/* <TableCell style={{marginLeft:}}>NO Data Found</TableCell> */}
                      {Norecordfd ? (
                        <SweetAlert
                          title=" No Data Found"
                          timeout={2000}
                          style={{
                            position: 'absolute',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                          showCloseButton={false}
                          showConfirm={false}
                          warning
                          onConfirm={() => {
                            setNorecordfd(false);
                          }}
                        ></SweetAlert>
                      ) : null}
                    </>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              component="div"
              rowsPerPageOptions={pages}
              count={dashboarddata.length}
              rowsPerPage={rowsperpage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}

export default DashboardOld;
